import React, {
  useEffect,
  useState,
  useContext
} from "react";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import "./RecentEntriesTable.css";
import ClaimTable from "../../claim/claim_table/ClaimTable";
import { ClaimAPI } from "../../claim/ClaimAPI";
import FormContext from "../../../context/FormContext";
import { errorToast } from "../../../toast";

const RecentEntriesTable = () => {
  const axiosPrivate = useAxiosPrivate();
  const [claimRecord, setClaimRecord] = useState([]);
  const {setIsLoading} = useContext(FormContext)

  const fetchClaimArray = async () => {
    try {
        setIsLoading(true)
        const response = await ClaimAPI(axiosPrivate, 6);
        if (response.status === 200) {
            setClaimRecord(response.data.results);
        }
    } catch (error) {
        errorToast(`Failed to fetch Claim list: error:${error.response.status}`, 2000);
    }
    finally{
        setIsLoading(false)
    }
};

  useEffect(() => {
    fetchClaimArray();
  }, []);

  const searchBarHandler = (e) => {
    axiosPrivate
      .get(`/dashboard/search_claim/?search=${e.target.value}&limit=6`)
      .then((response) => {
        setClaimRecord(response.data.results);
      });
  };

  return (
    <>
      <div className="entries-header-container">
        <p className="entries-header-name">Recent Entries</p>
        <input
          placeholder="Search Details"
          className="entries-header-input"
          type="text"
          onChange={searchBarHandler}
        />
      </div>
        {claimRecord && <ClaimTable
          claimRecord={claimRecord}
          setClaimRecord={setClaimRecord}
        />}
    </>
  );
};

export default RecentEntriesTable;
